import { render, staticRenderFns } from "./DetectionHistoryDetail.vue?vue&type=template&id=36156d3a&scoped=true"
import script from "./DetectionHistoryDetail.vue?vue&type=script&lang=js"
export * from "./DetectionHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36156d3a",
  null
  
)

export default component.exports